import { IBaseListDropdownOption } from '@tylertech/forge/esm/list-dropdown';
import { I18n } from 'common/i18n';

export enum FilterScope {
  RecentlyViewed = 'recently_viewed',
  EnrolledInArchival = 'enrolled_in_archival',
  ApprovalTypes = 'approval_types',
  Authority = 'authority',
  AssetTypes = 'asset_types',
  Source = 'source',
  Version = 'version',
  Visibility = 'visibility',
}

export const getScope = (scope: FilterScope): string => {
  return `shared.asset_browser.filters.${scope}`;
};

export const getAllOption = (scope: string): IBaseListDropdownOption => ({
  label: I18n.t('options.all', { scope }),
  value: null,
});
